export default "__VITE_ASSET__b2ab5bb3__"